// extracted by mini-css-extract-plugin
export default {"wrapper":"n1wmvDxk4cZCrsjsf5XO","link":"XoIb8KXuLdQawYIrzaMe","modalWrapper":"BZp9Z6RJH6Xwc8QCLxoi"};